import React from 'react';
import FlowIconSquare from '@Client/runner.directives/common/FlowIconSquare/FlowIconSquare';
import FlowModelSummaryTag from '@Client/runner.shared/FlowModelSummaryTag/FlowModelSummaryTag';
import { Guid } from '@Shared.Angular/@types/guid';
import IEntityTag from '@Shared.Angular/@types/core/contracts/queryModel/tagGroup/EntityTag';

type Props = {
  isMobile: boolean;
  flowModelSummary: IFlowModelSummary;
  onFlowModelClick(id: Guid): void;
  resetSearchItem?(): void;
  showConfidentialType?: boolean;
  showChips?: boolean;
};

const FlowModelSummary = (props: Props) => {
  const {
    flowModelSummary,
    isMobile,
    resetSearchItem,
    showConfidentialType,
    showChips
  } = props;

  return (
    <div className={`flow-start`} id={`flowactive_${flowModelSummary.id}`}>
      <div
        className="flow-start-header flex flex-row"
        role="button"
        tabIndex={0}
        aria-label={`Open flow model ${flowModelSummary.name}`}
        data-testid={`flow-model-open-${flowModelSummary.name}`}
        onClick={() => {
          resetSearchItem?.();
          props.onFlowModelClick(flowModelSummary.id);
        }}
      >
        {!isMobile && (
          <FlowIconSquare name={flowModelSummary.name} flowCode="" />
        )}

        {!isMobile && (
          <div className="flow-model-summary-container">
            <div className="flow-list__contents flex flex-row">
              <div className="flow-list__contents__subject">
                <div className="flow-list__contents__subject__text flex-column">
                  {flowModelSummary.name}
                </div>
                <div className="flow-list__contents__subject__created-by flex-column">
                  {flowModelSummary.category}
                </div>
              </div>
              <div className="flow-list__contents__description">
                {flowModelSummary.description}
              </div>
              <div className="flow-list__contents__process-owner">
                <div className="flow-list__contents__process-owner__text flex-column">
                  <div>Process Owner</div>
                  <div>{flowModelSummary.processOwnerName || 'N/A'}</div>
                </div>
              </div>

              {showChips && (
                <div className="chips">
                  {flowModelSummary.isDeleted && (
                    <div className="chip grey-chip">Deleted</div>
                  )}
                </div>
              )}

              {showConfidentialType && (
                <div className="flow-list__contents__workflow-type__block">
                  <div className="flow-list__contents__workflow-type__header flex-column">
                    Flow Type
                  </div>
                  <div className="flow-list__contents__workflow-type__text">
                    <div
                      className={
                        flowModelSummary.isConfidential
                          ? 'flow-list__contents__workflow-type__confidential'
                          : 'flow-list__contents__workflow-type__normal'
                      }
                    >
                      {flowModelSummary.isConfidential
                        ? 'Confidential Workflow'
                        : 'Workflow'}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {flowModelSummary.parsedTags.length > 0 && (
              <div className="flow-model-summary-tag-row">
                <FlowModelSummaryTag tags={flowModelSummary.parsedTags} />
              </div>
            )}
          </div>
        )}
        {isMobile && (
          <div className="flow-start-mobile">
            <div className="flex flow-header__main">
              <FlowIconSquare name={flowModelSummary.name} flowCode="" />
              <div className="flow-list__contents flex flex-row">
                <div className="flow-list__contents__subject--mobile mr-20">
                  <div className="flow-list__contents__subject__text flex-column">
                    {flowModelSummary.name}
                  </div>
                  <div className="flow-list__contents__subject__started-by flex-column">
                    {flowModelSummary.category}
                  </div>
                </div>
              </div>
            </div>
            <div className="flow-header__extra flow-header__extra--start-flow">
              {flowModelSummary.description}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default FlowModelSummary;

export interface IFlowModelSummary {
  id: Guid;
  name: string;
  description: string;
  category: string;
  processOwnerName?: string;
  parsedTags: IEntityTag[];
  isConfidential?: boolean;
  isDeleted?: boolean;
}
